"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.flex = function (isUser) {
  return typestyle_1.style({
    display: "flex"
  }, {
    justifyContent: isUser ? "flex-end" : "flex-start"
  });
};

exports.imageBox = function (isUser) {
  return typestyle_1.style({
    width: "45px"
  }, {
    minWidth: "45px"
  }, {
    height: "45px"
  }, {
    margin: "5px ".concat(!isUser ? "10px" : 0, " 5px ").concat(isUser ? "10px" : 0)
  }, {
    border: "1px solid #e1e1e1"
  }, {
    borderRadius: "50%"
  }, {
    padding: "8px"
  }, {
    order: isUser ? 1 : 0
  });
};

exports.textBox = function (layout) {
  return typestyle_1.style({
    position: "relative"
  }, {
    minWidth: "18%"
  }, {
    maxWidth: "500px"
  }, {
    padding: "16px"
  }, {
    boxShadow: "0 0px 0px 0 ".concat(layout.backgroundColor)
  }, {
    border: "1px solid #f1f1f1"
  }, {
    borderRadius: "10px 10px 35px 10px"
  }, {
    fontFamily: "inherit"
  }, {
    backgroundColor: layout.backgroundColor
  }, {
    fontSize: layout.fontSize
  }, {
    color: layout.color
  });
};